import React from 'react';
import Navbar from '../components/Navbar.js';
import Footer from '../components/Footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import BannerImage from '../components/img/about-us-banner.png';
import '../styles/pages.css';
import { FaChevronRight } from "react-icons/fa6";
import Card from '../components/img/about-us-card.png';

function AboutUs() {
    return (
        <div>
            {/* Navbar */}
            <Navbar />
            {/* Navbar Ending */}

            {/* Page Content starts here */}
            <section className="page-section">
                <div className="section-content">
                    <p className='page-heading'>About Caritas Matha Hospital</p>

                    <div className="d-none d-md-block"> {/* Only works in Desktop */}
                        <p className="page-subtitle">
                            Explore our unwavering commitment to delivering exceptional <br/>
                            healthcare services.
                        </p>
                    </div>

                    <div className="d-md-none mb-2">{/* Only works in mobiles */}
                        <p className="page-subtitle">
                            Explore our unwavering commitment to delivering exceptional healthcare services.
                        </p>
                    </div>
                    
                    <div className="about-us-banner">
                        <img src={BannerImage} alt="About Us Banner" />
                    </div>
                </div>
            </section>

            <section className="about-content-section">
                <div className="about-content-container">
                    <h2>Caritas Matha Hospital: Leading Healthcare Excellence  
                    <br/>in Kottayam with a Focus on Obstetrics & Gynecology</h2>
                    <div className="about-us-content">
                        <p>Caritas Matha Hospital, a 250-bed facility located in Kottayam, is dedicated to providing exceptional healthcare services with a primary focus on Obstetrics & Gynecology. Since its inception in 2000, operating under the name Matha Hospital, it has now become a satellite hospital of Caritas Hospital, enhancing the services and care provided by the esteemed Caritas Hospital team.</p>
                        <p>Situated in the heart of Kottayam, the hospital caters to diverse healthcare needs with a commitment to quality, innovation, and patient-centered care. Equipped with state-of-the-art facilities and staffed by a team of dedicated healthcare professionals, Caritas Matha Hospital continues to uphold the highest standards in medical treatment, aiming to enhance the health and well-being of the community it serves.</p>
                        <p>Specializing in Obstetrics & Gynecology, Caritas Matha Hospital stands as a beacon of healthcare excellence in Kottayam, offering state-of-the-art facilities and compassionate care to enhance women's health and well-being.</p>
                    </div>
                    <div className="about-us-counters">
                        <div className="about-counter">
                            <h2>10+</h2>
                            <p>Departments</p>
                        </div>
                        <div className="about-counter">
                            <h2>50+</h2>
                            <p>Doctors</p>
                        </div>
                        <div className="about-counter">
                            <h2>10+</h2>
                            <p>Medical Services</p>
                        </div>
                        <div className="about-counter bed-counter">
                            <h2>250</h2>
                            <p>Bed Facility</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="page-content-section">

                <div className="d-none d-md-block"> {/* Only works in Desktop */}
                    <p className="about-us-card-heading">
                        About Caritas Hospital: Step into the world of 
                        <br/> 
                        good health and happiness
                    </p>
                </div>

                <div className="d-md-none mb-2">{/* Only works in mobiles */}
                    <p className="about-us-card-heading">
                        About Caritas Hospital : Step into the world of good health and happiness
                    </p>
                </div>

                <div className="about-us-card">
                    <div className="about-card-image">
                        <img src={Card} alt="Card Image" />
                    </div>
                    <div className="about-card-content">
                        <p>Caritas Hospital, the parent brand of Caritas Matha Hospital, is renowned for its unwavering commitment to healthcare excellence. Established with a mission to deliver quality healthcare services with compassion and integrity, Caritas Hospital has expanded its footprint by nurturing a network of hospitals that uphold the highest standards of medical care. With a legacy of trust and innovation, Caritas Hospital continues to evolve, setting benchmarks in patient care and community health initiatives across the region.</p>
                        <br/>
                        <p>To discover more, visit the Caritas Hospital Website</p>
                        <br/>
                        <a href="https://caritashospital.org"><p className="read-more-link">Know More <FaChevronRight /> </p></a>
                    </div>
                </div>
            </section>

            {/* Page content ends here */}

            {/* Footer */}
            <Footer />
            {/* Footer Ending */}
        </div>
    );
}

export default AboutUs;